/* jshint esnext: true */
import { APP_NAME } from '../utils/environment';
import AbstractModule from './AbstractModule';

const MODULE_NAME = 'CarouselContent';
const EVENT_NAMESPACE = `${APP_NAME}.${MODULE_NAME}`;

export default class extends AbstractModule {
    constructor(options) {
        super(options);

        this.singleSpeed = 4000;
        this.multipleSpeed = 4000;
        this.timeout;
        this.slideshow = false;
        this.slideshowInterval;
    }

    init() {
        this.$el.on('init', (event) => this.checkImages());
        this.$el.on('afterChange', (event) => this.checkImages());

        this.$el.slick({
            dots: true,
            mobileFirst: true,
            cssEase: 'cubic-bezier(0.4, 0, 0.2, 1)',
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: false,
            pauseOnHover: false,
            autoplaySpeed: 4000,
            arrows: true,
            fade: true,
            speed: 900
        });
    }

    checkImages() {
        const $slide = this.$el.find('.js-carouselcontent-slide.slick-active');
        const $images = $slide.find('.js-carouselcontent-image');
        const imagesNum = $images.length;

        clearTimeout(this.timeout);

        if (this.slideShow) {
            this.resetSlideshow();
        }

        if (imagesNum > 1) {
            this.startSlideshow($images, imagesNum);
        } else {
            this.timeout = setTimeout(() => {
                this.nextSlide();
            }, this.singleSpeed);
        }
    }

    startSlideshow($images, imagesNum) {
        this.slideShow = true;

        let i = 0;
        this.slideshowInterval = setInterval( () => {
            if (i < imagesNum-1) {
                $images.eq(i).removeClass('is-current');
                i++;
                $images.eq(i).addClass('is-current');
            } else {
                clearInterval(this.slideshowInterval);
                this.nextSlide();
            }
        }, this.multipleSpeed);
    }

    resetSlideshow() {
        this.$el.find('.js-carouselcontent-image.is-current').removeClass('is-current');
        clearInterval(this.slideshowInterval);
        this.slideshow = false;
    }

    nextSlide() {
        this.$el.slick('slickNext');
    }

    destroy() {
        this.$el.slick('unslick');
        this.$el.off(`.${EVENT_NAMESPACE}`);
        super.destroy();
    }
}
